import { User } from './user.model';
import { ShowPerformance } from './showperformance.model';
import { LogDTO } from './LogDTO';
import { Picture } from './picture.interface.cs';
import { Image } from './image.model';
import { ImageAttachable } from './image-attachable';

export class Log implements ImageAttachable {
  createdAt?: Date | null = null;
  updatedAt?: Date | null = null;
  id?: number = 0;
  performance?: ShowPerformance = new ShowPerformance();
  toneelmeester?: User = new User();
  theatreMessage?: string = '';
  showMessage?: string = '';
  cleaningMessage?: string = '';
  companycallMessage?: string = '';
  otherMessage?: string = '';
  status?: string = 'CONCEPT';

  /**
   * @deprecated Legacy base64 images returned by the BE for logs that
   * pre-date the volume refactor. Kept so old logs still render in
   * `log-details`; new uploads go through `images` + `imageIds`. Slated
   * for removal in phase 2.
   */
  pictures?: Picture[] = [];

  /** Disk-backed images attached to this log (post-volume-refactor). */
  images?: Image[] = [];

  /** Newly-uploaded ImageFile ids added during this edit session. */
  imageIds?: number[] = [];

  /** Existing image ids the user removed during this edit session. */
  removedImageIds?: number[] = [];

  submittedBy?: User = null;
  updatedBy?: User = null;

  public convertToDTO(): LogDTO {
    const logDTO = new LogDTO();
    logDTO.performanceId = this.performance.id;
    logDTO.theatreMessage = this.theatreMessage;
    logDTO.showMessage = this.showMessage;
    logDTO.cleaningMessage = this.cleaningMessage;
    logDTO.companycallMessage = this.companycallMessage;
    logDTO.otherMessage = this.otherMessage;
    logDTO.toneelmeesterId = this.toneelmeester.id;
    logDTO.status = this.status;
    // New disk-backed flow.
    logDTO.imageIds = this.imageIds ?? [];
    logDTO.removedImageIds = this.removedImageIds ?? [];
    // Deprecated base64 flow — never written by the new FE; null tells
    // the BE legacy branch to no-op.
    logDTO.pictures = null;
    return logDTO;
  }

  public createFromJson(json: any): Log {
    const instance = new Log();

    instance.createdAt = json.createdAt ?? null;
    instance.updatedAt = json.updatedAt ?? null;
    instance.id = json.id ?? 0;
    instance.theatreMessage = json.theatreMessage || '';
    instance.showMessage = json.showMessage || '';
    instance.cleaningMessage = json.cleaningMessage || '';
    instance.companycallMessage = json.companycallMessage || '';
    instance.otherMessage = json.otherMessage || '';
    instance.status = json.status || 'CONCEPT';

    if (json.performance) {
      instance.performance = new ShowPerformance().createFromJson(json.performance);
    }

    if (json.toneelmeester) {
      instance.toneelmeester = new User().createFromJson(json.toneelmeester);
    }

    // Legacy base64 images — kept for old logs.
    if (Array.isArray(json.pictures)) {
      instance.pictures = [...json.pictures];
    }

    // Disk-backed images — the new pipeline. The BE returns these via
    // the @Transient Log.images field populated from data_images rows.
    if (Array.isArray(json.images)) {
      instance.images = json.images.map((img: any) => Image.createFromJson(img));
    }

    instance.imageIds = [];
    instance.removedImageIds = [];

    if (json.submittedBy) {
      instance.submittedBy = new User().createFromJson(json.submittedBy);
    }

    if (json.updatedBy) {
      instance.updatedBy = new User().createFromJson(json.updatedBy);
    }

    return instance;
  }

}
